import React from 'react';
import { IncidentMapCanvas } from '../../components/law/IncidentMapCanvas';
import { IncidentSummaryPanel } from '../../components/law/IncidentSummaryPanel';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import { demoIncidents, Incident } from './incidentsData';

export function IncidentMap() {
  const [selectedIncident, setSelectedIncident] = React.useState<Incident | null>(null);
  const closeIncident = React.useCallback(() => setSelectedIncident(null), []);

  useEscapeKey(Boolean(selectedIncident), closeIncident);

  return (
    <div className="incident-map-page">
      <IncidentMapCanvas incidents={demoIncidents} onSelectIncident={setSelectedIncident} />

      {selectedIncident ? (
        <IncidentSummaryPanel incident={selectedIncident} onClose={closeIncident} />
      ) : null}
    </div>
  );
}
